module.exports = __webpack_public_path__ + "static/media/step3.a567ef54.png";